import HttpService from "./http.service";

class ReportsService {
  genesisReport = async ({ startDate, endDate, accountGroup, supplierId }) => {
    const reportsEndpoint = `/reports/genesis-report?${
      startDate && `startDate=${startDate}`
    }&${endDate && `endDate=${endDate}`}&${
      accountGroup && `accountGroup=${accountGroup}`
    }&${supplierId && `supplierId=${supplierId}`}`;

    return await HttpService.get(reportsEndpoint);
  };

  saldoDiario = async (dia = null) => {
    const reportsEndpoint = `/reports/saldo-diario${dia ? `?dia=${dia}` : ""}`;
    return await HttpService.get(reportsEndpoint);
  };

  // Fluxo de caixa: { dataInicio, dataFim (AAAA-MM-DD), account, empresa }
  fluxoCaixa = async (filtros = {}) => {
    const qs = new URLSearchParams(
      Object.entries(filtros).filter(([, v]) => v)
    ).toString();
    return await HttpService.get(`/reports/saldo-entre-datas?${qs}`);
  };

  saldoDiarioFiltrado = async (filtros = {}) => {
    const qs = new URLSearchParams(
      Object.entries(filtros).filter(([, v]) => v)
    ).toString();
    return await HttpService.get(`/reports/saldo-diario?${qs}`);
  };

  saldoEntreDatas = async (dataInicio = null, dataFim = null) => {
    const reportsEndpoint = `/reports/saldo-entre-datas?${
      dataInicio ? `dataInicio=${dataInicio}` : ""
    }&${dataFim ? `dataFim=${dataFim}` : ""}`;
    return await HttpService.get(reportsEndpoint);
  };

  carregamentoDia = async (dia = null) => {
    const reportsEndpoint = `/reports/carregamento-dia${
      dia ? `?dia=${dia}` : ""
    }`;
    return await HttpService.get(reportsEndpoint);
  };

  relatorioPorCentroDeCusto = async ({
    dataInicio,
    dataFim,
    centroDeCusto,
    tipo,
    tipoDataFiltrar,
  }) => {
    const reportsEndpoint = `/reports/relatorio-por-centro-de-custo?dataInicio=${dataInicio}&dataFim=${dataFim}&centroDeCusto=${centroDeCusto}&tipo=${tipo}&tipoDataFiltrar=${tipoDataFiltrar}`;
    return await HttpService.get(reportsEndpoint, {
      responseType: "arraybuffer",
      headers: {
        Accept: "application/pdf",
      },
    });
  };

  pedidosSemContas = async ({ tipo }) => {
    const reportsEndpoint = `/reports/pedidos-sem-contas?tipo=${tipo}`;
    return await HttpService.get(reportsEndpoint);
  };

  relatorioProdutividade = async ({
    startDate,
    endDate,
    customerId,
    status,
  }) => {
    const reportsEndpoint = `/reports/relatorio-produtividade?${
      startDate && `startDate=${startDate}`
    }&${endDate && `endDate=${endDate}`}&${
      customerId && `customerId=${customerId}`
    }&${status && `status=${status}`}`;

    return await HttpService.get(reportsEndpoint);
  };
}

export default new ReportsService();
